import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from "../../Header";
import Footer from "../../Footer";
import ZaptranceSideNav from './ZaptranceSideNav';
import HeaderZaptrance from './HeaderZaptrance';

import logginImgTwo from '../../../assets/logo.png';

import icon from '@mui/icons-material/Home';
import SettingsIcon from '@mui/icons-material/Settings';

const ZaptranceSettingsContact = () => {
    const navigate = useNavigate();

    const [email, setEmail] = useState('Please enter your email');
    const [phoneNumber, setPhoneNumber] = useState('Please enter your phone number');
    const [message, setMessage] = useState('Please enter your message');

    const buttonContainerStyle = {
        display: 'flex',
        justifyContent: 'center', // Center horizontally
        marginTop: '20px', // Add margin for spacing
    };

    const buttonStyle = {
        // Add your button styles here
        //height: 60,
    };


    let token = localStorage.getItem('token');
    useEffect(() => {
      if (!token) {
        // Redirect to the home page if the token is null
        navigate('/');
      } else {
        // If the user is authenticated, call the handleData function
        //handleData();
      }
    }, [navigate]);

    const handlePhoneNumberChange = (e) => {
        const value = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
        setPhoneNumber(value);
      };

    return (
        <div className="content flex-grow">
                <div className="inner-content">
                    <HeaderZaptrance />
                    <div className=' p-4' style={{backgroundColor: '#F6F7FB'}}>
                    <div className='text-black p-4 flex text-xl'>
                            <div><SettingsIcon className='mr-4'/></div>Settings
                        </div>
                        
                        <div className="flex justify-between">
                            <div className="rounded-lg p-4 flex-1 m-2 flex-col text-black" style={{backgroundColor: '#ffffff'}}> 

                            <div className="rounded-lg p-4 flex-1 m-2 flex-col text-black" > 
                            Complete the following information to get response from admin
                                    <div className='flex flex-col py-2'>
                                        <label>Email</label>
                                        <input style={{backgroundColor: '#EDF2F6'}}
                                        className='rounded-l mt-2 p-2 focus' type='text' value={email} onChange={(e) => setEmail(e.target.value)} />
                                    </div>
                                    <div className='flex flex-col py-2'>
                                        <label>Phone Number</label>
                                        <input style={{backgroundColor: '#EDF2F6'}}
                                        className='rounded-l mt-2 p-2 focus' type='text' value={phoneNumber} onChange={handlePhoneNumberChange} />
                                    </div>
                                    <div className='flex flex-col py-2'>
                                        <label>Message</label>
                                        <input style={{backgroundColor: '#EDF2F6'}}
                                        className='rounded-l mt-2 p-2 focus' type='text' value={message} onChange={(e) => setMessage(e.target.value)} />
                                    </div>
                                    
                                </div>
                            <div style={buttonContainerStyle} className='pt-8'>
                                <button className="rounded-button" style={buttonStyle}>Send Message</button>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    );
}

export default ZaptranceSettingsContact;
